<template>
  <div>
    <el-card
      shadow="never"
    >
      <el-row
        slot="header"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <div>
          <h3>
            {{ title }}
          </h3>
        </div>
      </el-row>
      <ColumnChart
        :series="series"
        :labels="labels"
      />
    </el-card>
  </div>
</template>

<script>
import ColumnChart from "../../../components/charts/Column.vue"

export default {
  name: "DashboardColumnChart",
  components: {
    ColumnChart
  },
  props: {
    title: String,
    data: Array
  },
  computed: {
    series() {
      return this.data.map((d) => ({
        name: d.name,
        data: d.count.map((c) => c.value)
      }));
    },
    labels() {
      return this.data[0]?.count?.map((c) => c.label);
    }
  }
};
</script>

<style lang="scss" scoped></style>
